import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentSectionsComponent } from './document-sections.component';
import { AddDocumentSectionsComponent } from './add-document-sections/add-document-sections.component';
import { EditDocumentSectionsComponent } from './edit-document-sections/edit-document-sections.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        DocumentSectionsComponent,
        AddDocumentSectionsComponent,
        EditDocumentSectionsComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [DocumentSectionsComponent],
})
export class DocumentSectionsModule { }
